<div>
  <ul class="maplayer">
    <li class="basemap-close">
      <button type="button" class="close" (click)="hideBaseMapView()">
        <div class="csx-common_delete cross-icon"></div>
      </button>
    </li>
    <li>
      <button
        (click)="switchSytle('Dark')"
        title="Dark"
        type="button"
        class="maptype csx-Mapview_Dark"
        [ngClass]="{ active: baseMapType === 'Dark' }"
      ></button>
    </li>
    <li>
      <button
        (click)="switchSytle('Mono')"
        title="Mono"
        type="button"
        class="maptype csx-Mapview_Mono"
        [ngClass]="{ active: baseMapType == 'Mono' }"
      ></button>
    </li>
    <li>
      <button
        (click)="switchSytle('Roads')"
        type="button"
        title="Roads"
        class="maptype csx-Mapview_Roads"
        [ngClass]="{ active: baseMapType == 'Roads' }"
      ></button>
    </li>
  </ul>
</div>
